import { ThemeOptions } from '@material-ui/core/styles';

const theme = {
  palette: {
    primary: {
      main: '#0A6991',
      contrastText: '#fff',
    },
    secondary: {
      main: '#e63445',
    },
    warning: {
      main: '#ffc107',
      light: '#fff3cd',
      dark: '#856404',
      contrastText: '#212529',
    },
    error: {
      main: '#DE4151',
      light: '#f8d7da',
      dark: '#721c24',
      contrastText: '#fff',
    },
    success: {
      main: '#28a745',
      light: '#d1edff',
      dark: '#155724',
      contrastText: '#fff',
    },
    info: {
      main: '#17a2b8',
      light: '#d1ecf1',
      dark: '#0c5460',
      contrastText: '#fff',
    },
    channel: {
      sms: '#1890ff',
      smsDark: '#096dd9',
      whatsapp: '#25d366',
      whatsappDark: '#128c7e',
    },
    secure: {
      main: '#52c41a',
      bgStart: '#f6ffed',
      bgEnd: '#f0f9ff',
      border: '#b7eb8f',
    },
  },
} as ThemeOptions;

export default theme;
